import { useEffect, useState } from "react";
import { Button, Form, Input, Modal, Select, Space } from "antd";
import type { DataNode } from "antd/es/tree";

import StringUtils from "../../../../util/StringUtils";
import DeviceGroupApi from "../../../../api/DeviceGroupApi";

interface EditGroupModalProps {
    editingGroup: any;
    onClose: () => void;
    onComplete: () => void;
}

interface DeviceGroup {
    id?: string;
    name: string;
    groupId?: string;
}

const EditGroupModal: React.FC<EditGroupModalProps> = (props)=> {
    // api
    let deviceGroupApi = new DeviceGroupApi();

    // form
    let [form] = Form.useForm();

    // state
    let [loading, setLoading] = useState(false);

    // events
    let onCancel = () => {
        props.onClose();
    };

    let onOk = async () => {
        try {
            let values = await form.validateFields();
            setLoading(true);

            let data: any = {
                id: props.editingGroup.id,
                name: values.name,
                groupId: props.editingGroup.parentId,
            };

            if (data.id) {
                // update existing group
                await deviceGroupApi.update(data);
            } else {
                // create new group
                data.isGroup = true;
                await deviceGroupApi.create(data);
            }

            props.onComplete();
        } catch (error) {
            console.error("Form validation failed:", error);
        } finally {
            setLoading(false);
        }
    };

    // initialize form
    useEffect(() => {
        form.setFieldsValue({
            name: props.editingGroup.title,
        });
    }, [props.editingGroup]);

    return (
        <div style={{ padding: '20px' }}>
            <Form
                form={form}
                layout="vertical"
                autoComplete="off">
                <Form.Item
                    label="分组名称"
                    name="name"
                    rules={[
                        { required: true, message: '请输入分组名称' },
                        { max: 100, message: '分组名称不能超过100个字符' }
                    ]}>
                    <Input placeholder="请输入分组名称" maxLength={100} />
                </Form.Item>
            </Form>

            <div style={{ textAlign: 'right', marginTop: '20px' }}>
                <Space>
                    <Button onClick={onCancel}>取消</Button>
                    <Button type="primary" onClick={onOk} loading={loading}>
                        {props.editingGroup ? '保存' : '创建'}
                    </Button>
                </Space>
            </div>
        </div>
    );
}

export default EditGroupModal;
